var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,7h7.34c1.34,0,2.59-.52,3.54-1.46l2.66-2.66c.57-.57,1.32-.88,2.12-.88h6.34c.55,0,1-.45,1-1s-.45-1-1-1h-6.34c-1.34,0-2.59,.52-3.54,1.46l-2.66,2.66c-.57,.57-1.32,.88-2.12,.88H1c-.55,0-1,.45-1,1s.45,1,1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23,22H13.66c-.8,0-1.56-.31-2.12-.88l-4.66-4.66c-.94-.94-2.2-1.46-3.54-1.46H1c-.55,0-1,.45-1,1s.45,1,1,1H3.34c.8,0,1.56,.31,2.12,.88l4.66,4.66c.94,.94,2.2,1.46,3.54,1.46h9.34c.55,0,1-.45,1-1s-.45-1-1-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,11c0-.55-.45-1-1-1H1c-.55,0-1,.45-1,1s.45,1,1,1H9.59l4.54,4.54c.94,.94,2.2,1.46,3.54,1.46h5.34c.55,0,1-.45,1-1s-.45-1-1-1h-5.34c-.8,0-1.56-.31-2.12-.88l-3.12-3.12h10.59c.55,0,1-.45,1-1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphs);
export default __webpack_public_path__ + "static/media/graphs.43256fb9d7822898f54250d03b0ee53c.svg";
export { ForwardRef as ReactComponent };